import moment from 'moment-timezone';
import { extendMoment } from 'moment-range';

export default extendMoment(moment);
